import {exeRequest} from '../utils/APIUtils'

export default {
 generate: async  (phoneNumber) => exeRequest(`/api/otp/generate?phoneNumber=${phoneNumber}`, "POST"),
 verify: async  (phoneNumber, otp) => exeRequest(`/api/otp/validate?phoneNumber=${phoneNumber}&otp=${otp}`, "POST"),
}